import React, { useCallback, useContext, useState } from 'react';
import { useForm } from 'react-hook-form';
import { BuscaProduto } from '~/components/NovosInputs';
import { LojaContext } from '~/context/loja';
import { ClonarProdutoContent } from './styles';
import { useMediaQuery } from '~/hooks/useMediaQuery';
import {
  ProdutoClonado,
  SessionStorageService,
} from '../../class/SessionStorageService';

interface FormClonarProps {
  codTela: number;
  onHide: () => void;
  lojaSelected?: number | number[];
}

export const FormClonarProduto: React.FC<FormClonarProps> = ({
  codTela,
  onHide,
  lojaSelected,
}) => {
  const { loja } = useContext(LojaContext);
  const menor991 = useMediaQuery({ maxWidth: 991 });

  const [produtoSelected, setProdutoSelected] = useState<ProdutoClonado | null>(
    null,
  );

  const { register, control, setValue } = useForm({
    reValidateMode: 'onSubmit',
  });

  const onCancel = useCallback(() => {
    onHide();
    setProdutoSelected(null);
  }, [onHide]);

  return (
    <ClonarProdutoContent>
      <BuscaProduto
        label="Produto Base:"
        placeholder="Selecione..."
        name="produto_base"
        register={register}
        isError={false}
        buscaItensInativos={false}
        showTootltip
        control={control}
        buscaNasLojas={lojaSelected ?? loja.cod_loja}
        getProduct={(selected: any) => {
          const produto = selected[0];

          if (!produto) return;

          const data: ProdutoClonado = {
            p_cod_loja: lojaSelected ?? loja.cod_loja,
            p_cod_produto_origem: produto.cod_produto,
            p_gtin: produto.cod_gtin_principal,
            p_cod_departamento: produto.cod_departamento,
            p_cod_ncm: produto.cod_ncm,
            p_val_venda: produto.val_preco,
            p_qtd_estoque: produto.qtd_est_atual,
            p_des_produto: produto?.des_reduzida?.toUpperCase()?.trim(),
          };

          setProdutoSelected(data);
        }}
        setValue={setValue}
        customOptions={{
          hideBuscarPor: true,
          buscarPor: ['Produto'],
          buscaPadrao: 'Produto',
        }}
        listWidth={menor991 ? '28.9375rem' : '47.8125rem'}
      />
      <div className="button-content">
        <button
          type="button"
          onClick={onCancel}
          style={{ backgroundColor: '#cf2a27' }}
        >
          Cancelar
        </button>
        <button
          disabled={!produtoSelected}
          type="button"
          style={{ backgroundColor: '#009e0f' }}
          onClick={() => {
            if (!produtoSelected) return;

            SessionStorageService.saveProduto(
              'produto-clonado',
              produtoSelected,
              codTela,
            );

            onCancel();
          }}
        >
          Confirmar
        </button>
      </div>
    </ClonarProdutoContent>
  );
};
